import React from 'react'

const NiExport = () => {
  return (
   <svg width="24" height="24" class="mb-4 text-text-primary" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.0174 6.36488C21.5776 11.7901 19.2565 16.9642 15.5338 20.9351C13.6427 22.9523 10.2117 21.8996 9.86873 19.1559L9.51018 16.2874C9.3967 15.3796 8.68158 14.6645 7.7737 14.551L4.90527 14.1924C2.16158 13.8494 1.10884 10.4185 3.12605 8.52733C7.09694 4.80462 12.271 2.48359 17.6963 2.04371C20.1608 1.84388 22.2173 3.90033 22.0174 6.36488Z" stroke="currentColor" stroke-width="1.5"></path><path opacity="0.6" d="M9.31738 14.7441L12.4994 11.5622" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>
  )
}

export default NiExport
